<template>
    <kt-row>
        <kt-col lg="4" md="6" sm="12">
            <kt-form-group>
                <kt-form-label for="merchant_number">
                    {{ $t('label.merchant_number') }}
                </kt-form-label>
                <kt-form-control
                        id="merchant_number"
                        name="merchant_number"
                        v-model="form_data.merchant_number"
                        class="form-control"
                ></kt-form-control>
            </kt-form-group>
        </kt-col>
        <kt-col lg="4" md="6" sm="12">
            <kt-form-group>
                <kt-form-label for="terminal_number">
                    {{ $t('label.terminal_number') }}
                </kt-form-label>
                <kt-form-control
                        id="terminal_number"
                        name="terminal_number"
                        v-model="form_data.terminal_number"
                        class="form-control"
                ></kt-form-control>
            </kt-form-group>
        </kt-col>
        <kt-col lg="4" md="6" sm="12">
            <kt-form-group>
                <kt-form-label for="password">
                    {{ $t('label.password') }}
                </kt-form-label>
                <kt-form-control
                        id="password"
                        name="password"
                        v-model="port_config.password"
                        class="form-control"
                ></kt-form-control>
            </kt-form-group>
        </kt-col>
    </kt-row>
</template>

<script>
export default {
    props: {
        form_data: {
            required: true
        },
        port_config: {
            required: true
        }
    },
}
</script>

<style>
</style>